module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Hong Kong is a former British colony and – since 1997 – a special region of China, located in the South China Sea.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Ethnic Chinese make up more than 93.6 per cent of the population of roughly 7.4 million. Expatriates account for 4.6 per cent, representing countries from all over the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Hong Kong is a highly significant global financial centre. Its people enjoy some of the longest life expectancies and the highest national IQ estimate in the world. It is generally safe and peaceful.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("However, there has been significant political turmoil in recent years, marked by democratic reform protests, some of which have resulted in violence and mass arrests.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("There are many diverse and intriguing characters that have made their fortune – or are planning on it – in this vibrant city. As is often the case with those seeking the excitement of riches, some of them will do anything to get the results they want.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145ca30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 69
// module chunks = 0